/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */

import styled from 'styled-components';

export const PageContainerStyled = styled.div.attrs({
    className: 'page-wrapper',
})`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 98vh;
    flex: 1 0 100%;
    margin: 0;
`;
